import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import FoldersContent from "./FoldersContent";

const FoldersContentMain = (props) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // Get folder data from location state or props
  const folder = location.state?.folder || props.folder || {};
  const folderName = folder.name || t('document_repo');
  useEffect(() => {
    GridStack.init();
  }, []);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={folderName}
          fileName="Document Repository"
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <FoldersContent folderId={folder.id} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default FoldersContentMain;